import axiosInstance from "./axios-instance";

const listOptions = (types) =>
    axiosInstance.get("/app/lookup-options", {
        params: { types: types.join(",") },
        cache: false,
    }).then(res => res);

export default {
    listOptions,
};
